export const loyaltyPointsConstants = {
  GET_MY_POINTS_REQUEST: "GET_MY_POINTS_REQUEST",
  GET_MY_POINTS_SUCCESS: "GET_MY_POINTS_SUCCESS",
  GET_MY_POINTS_FAILURE: "GET_MY_POINTS_FAILURE",

  GET_MONTHWISE_POINTS_REQUEST: "GET_MONTHWISE_POINTS_REQUEST",
  GET_MONTHWISE_POINTS_SUCCESS: "GET_MONTHWISE_POINTS_SUCCESS",
  GET_MONTHWISE_POINTS_FAILURE: "GET_MONTHWISE_POINTS_FAILURE",
};
